import React from "react";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import { green } from "@mui/material/colors";
import CheckIcon from "@mui/icons-material/Check";

// Switch estilizado (verde al estar activo, gris al estar apagado).
// El estado "off" usa el color neutro por defecto para que la diferencia
// visual entre encendido/apagado sea clara.
const GreenSwitch = (props) => (
  <Switch
    {...props}
    icon={<Box width={20} height={20} borderRadius="50%" bgcolor="#bdbdbd" />}
    checkedIcon={
      <Box
        width={20}
        height={20}
        borderRadius="50%"
        bgcolor={green[500]}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CheckIcon style={{ fontSize: 14, color: "#fff" }} />
      </Box>
    }
    sx={{
      "& .MuiSwitch-switchBase.Mui-checked": {
        color: green[500],
      },
      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: green[500],
      },
    }}
  />
);

/**
 * SwitchCustom
 * Switch reutilizable envuelto en un Box con borde outlined y label flotante,
 * imitando el look de un TextField outlined sin el hack de
 * TextField > inputComponent (que rompe accesibilidad y dispara el warning de
 * refs en function components).
 *
 * @param {boolean}  checked  - Estado del switch.
 * @param {function} onChange - Handler nativo del Switch (recibe el evento).
 * @param {boolean}  disabled - Deshabilita el control.
 * @param {string}   label    - Texto del label flotante.
 * @param {string}   name     - Nombre del campo (útil con checkboxOnChange de useForm).
 */
export const SwitchCustom = ({
  checked,
  onChange,
  disabled = false,
  label = "",
  name,
  ...rest
}) => (
  <Box
    // Clases estables para que globalStyles.css ajuste el borde y el label en modo oscuro
    className="gn4-switch-box"
    border={1}
    borderColor="rgba(0, 0, 0, 0.23)"
    borderRadius={4}
    height={56}
    width="100%"
    display="flex"
    alignItems="center"
    justifyContent="center"
    position="relative"
  >
    {label ? (
      <Typography
        variant="caption"
        className="gn4-switch-label"
        style={{
          position: "absolute",
          top: -8,
          left: 12,
          backgroundColor: "#fff",
          paddingLeft: 4,
          paddingRight: 4,
          color: "rgba(0, 0, 0, 0.54)",
        }}
      >
        {label}
      </Typography>
    ) : null}
    <GreenSwitch
      name={name}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      {...rest}
    />
  </Box>
);

export default SwitchCustom;
